import { Injectable, Output, EventEmitter, Directive } from '@angular/core'
import { UserService } from '../services/user.service';
import { ServerService } from '../services/server.service';
import { LlRolesService } from './ll-roles.service';
import { LlModelsService } from './ll-models.service';
//import { LlCompaniesService } from './ll-companies.service';
import { LlPermissionsService } from './ll-permissions.service';


@Directive()
@Injectable({
  providedIn: 'root'
})

export class LlExamService {
  
  constructor(public ServerService: ServerService,
    private UserService: UserService,
    private LlRolesService: LlRolesService,
    private LlModelsService: LlModelsService,
    private LlPermissionsService: LlPermissionsService,
  ) { }  

  vars = {
    ac: "",
    APPLICATIONVERSION: "",
    CONTACTID: 0,
    COMPANYID: 0,
    COMPANYID_ACTIVE:0,
    STUDYID_SYS: 0,
    CONTACTROLEID: 0,
    SYSTEMROLEID: 0,
    LOANMODELID:0,
    EXAMID: 0,
    SYSTEMPRODUCTSECTIONID: 0,
    ACTIVE_ELEMENT: '',
    NEWVALUE:'',
    EXAM_OBJ: [],
  }
    
  bundle_local = {

    //studyVisits: [],
    //studyForms: [],
    //studyVisitForms: [],
    //studyQuestions: [],
    //questionChoices: [],

    //inBundle: [],    
    benchmarkValues: [],

    vars: this.vars,
  }

  setActiveEXAMID(ID) {
    this.bundle_local.vars.EXAMID = ID;
  }

  getActiveEXAMID() {
    return this.bundle_local.vars.EXAMID;
  }

  setActiveSYSTEMPRODUCTSECTIONID(ID) {
    this.bundle_local.vars.SYSTEMPRODUCTSECTIONID = ID;
  }

  getActiveSYSTEMPRODUCTSECTIONID() {
    return this.bundle_local.vars.SYSTEMPRODUCTSECTIONID;
  }

  NG_LL_model_examList_get(callback01?: Function) {

    var user = this.UserService.getActiveUser();

    this.bundle_local.vars.LOANMODELID = this.LlModelsService.getActiveId()

    this.bundle_local.vars.ac = "NG_LL_model_examList_get"
    this.bundle_local.vars.APPLICATIONVERSION = user.APPLICATIONVERSION;
    this.bundle_local.vars.CONTACTID = user.CONTACTID;
    this.bundle_local.vars.COMPANYID = user.COMPANYID;
    this.bundle_local.vars.CONTACTROLEID = this.LlRolesService.getActiveContactRoleId();
    this.bundle_local.vars.SYSTEMROLEID = this.LlRolesService.getActiveSystemRoleId();  

    this.ServerService.callserver(srvReturn, this.bundle_local, "show");

    function srvReturn(arr, bundle_local) {

      ///console.log(arr)

      if (arr.length > 0) {
        bundle_local.vars.EXAMID = arr[0].EXAMID;
      }

      callback01(arr);    

    }

  }


  NG_LL_model_exam_sectionList_get(callback01?: Function) {

    this.bundle_local.vars.ac = "NG_LL_model_exam_sectionList_get"

    this.ServerService.callserver(srvReturn, this.bundle_local, "show");

    function srvReturn(arr, bundle_local) {

      ///console.log(arr)

      if (arr.length > 0) {
        bundle_local.vars.SYSTEMPRODUCTSECTIONID = arr[0].SYSTEMPRODUCTSECTIONID;
      }

      callback01(arr);

    }

  }

  NG_LL_model_exam_section_scope_get(callback01?: Function) {

    this.bundle_local.vars.ac = "NG_LL_model_exam_section_scope_get"

    this.ServerService.callserver(srvReturn, this.bundle_local, "show");

    function srvReturn(arr, bundle_local) {

      ///console.log(arr)

      callback01(arr);

    }

  }

  NG_LL_model_exam_section_scope_edit(callback01: Function, ELEMENT, NEWVALUE) {

    this.bundle_local.vars.ac = "NG_LL_model_exam_section_scope_edit"
    this.bundle_local.vars.ACTIVE_ELEMENT = ELEMENT;
    this.bundle_local.vars.NEWVALUE = NEWVALUE;

    this.ServerService.callserver(srvReturn, this.bundle_local, "show");

    function srvReturn(arr, bundle_local) {

      ///console.log(arr)

      callback01();

    }

  }

  NG_utility_monthEnds_get(callback01?: Function) {

    this.bundle_local.vars.ac = "NG_utility_monthEnds_get"

    this.ServerService.callserver(srvReturn, this.bundle_local, "show");

    function srvReturn(arr, bundle_local) {

      ///console.log(arr)

      callback01(arr);

    }

  }

  NG_LL_model_exam_section_scope_contact_add(callback01: Function, EXAM_OBJ) {

    this.bundle_local.vars.ac = "NG_LL_model_exam_section_scope_contact_add"
    this.bundle_local.vars.EXAM_OBJ = EXAM_OBJ;

    this.ServerService.callserver(srvReturn, this.bundle_local, "show");

    function srvReturn(arr, bundle_local) {

      ///console.log(arr)

      callback01();

    }


  }

  NG_LL_model_exam_section_locations_get(callback01?: Function) {

    this.bundle_local.vars.ac = "NG_LL_model_exam_section_locations_get"

    this.ServerService.callserver(srvReturn, this.bundle_local, "show");

    function srvReturn(arr, bundle_local) {

      ///console.log(arr)

      callback01(arr);

    }

  }

  NG_LL_model_exam_section_receivables_get(callback01?: Function) {

    this.bundle_local.vars.ac = "NG_LL_model_exam_section_receivables_get"

    this.ServerService.callserver(srvReturn, this.bundle_local, "show");

    function srvReturn(arr, bundle_local) {

      ///console.log(arr)

      callback01(arr);

    }

  }



}
